import { DreamValue } from '@/sharedComponents/TextEditor/plate';
import { ITemplate, TEMPLATE_TYPE } from '@typedream/data';
import { Dispatch, ReactNode, SetStateAction, createContext } from 'react';
import { ISpaceCustomization, PageTemplateType } from '../../../types';
import { SAVE_TEMPLATE_PAGE } from '../types';
/**
 * The Save Template Popup Context
 */

export interface SaveTemplatePopupContextInterface {
  open: boolean;
  setopen: Dispatch<SetStateAction<boolean>>;
  step: SAVE_TEMPLATE_PAGE;
  setstep: Dispatch<SetStateAction<SAVE_TEMPLATE_PAGE>>;
  content: DreamValue;
  setcontent: Dispatch<SetStateAction<DreamValue>>;
  customization: ISpaceCustomization;
  setcustomization: Dispatch<SetStateAction<ISpaceCustomization>>;
  err: string | ReactNode;
  seterr: Dispatch<SetStateAction<string | ReactNode>>;
  templates: PageTemplateType[];
  settemplates: Dispatch<SetStateAction<PageTemplateType[]>>;
  templateToUpdate: PageTemplateType;
  settemplateToUpdate: Dispatch<SetStateAction<PageTemplateType>>;
  loadingTemplates: boolean;
  categoryOptions: string[];
  templateType: TEMPLATE_TYPE;
  onCreateTemplate: (props: {
    name: string;
    description: string;
    category: string[];
    previewImageFile: File;
    pid?: string;
  }) => Promise<ITemplate<TEMPLATE_TYPE.PAGE>> | Promise<void>;
  onUpdateTemplate: () => Promise<void>;
  pageID: string | null;
  setPageID: Dispatch<SetStateAction<string>>;
}

export const SaveTemplatePopupContext = createContext<SaveTemplatePopupContextInterface>(null);
